import React from 'react'
import styled from 'styled-components'
import { PricelineLogoNR } from '@pcln/brand-logos'
import { VipIcon, TierBadge } from '@pcln/vip'
import { Flex, Box, Text, Link } from 'pcln-design-system'
import PropTypes from 'prop-types'

const UnderlineLink = styled(Link)`
  text-decoration: underline;
`

const ExpressDealVipInfo = ({
  vipSavingsPercent,
  promptSignIn,
  vipTier,
  justifyContent = ['flex-end', 'center'],
  enableExpressDealVip,
  ...props
}) => (
  <Box {...props}>
    <Flex data-testid='exd-vip-pricebox-icons' justifyContent={justifyContent} alignItems='center'>
      {vipTier ? (
        <TierBadge level={vipTier} size={'small'} data-testid='exd-vip-pricebox-icons-tierbadge' />
      ) : (
        <Flex data-testid='exd-no-vip-tier-logo' alignItems='center'>
          <PricelineLogoNR />
          <VipIcon fontSize='24px' variation='vip' ml={2} />
        </Flex>
      )}
    </Flex>
    {!!promptSignIn && enableExpressDealVip && (
      <Box>
        <Text color='primary.dark' my={1} fontSize={1} bold>
          Get {vipSavingsPercent}% Off
        </Text>
        <UnderlineLink
          data-testid='expressdeal-vipinfo-link'
          /* istanbul ignore next */
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            promptSignIn()
          }}
        >
          <Text fontSize={0}>when you sign in</Text>
        </UnderlineLink>
      </Box>
    )}
  </Box>
)

ExpressDealVipInfo.propTypes = {
  vipSavingsPercent: PropTypes.string,
  enableExpressDealVip: PropTypes.bool,
  promptSignIn: PropTypes.func,
  vipTier: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  justifyContent: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
}

export { ExpressDealVipInfo }
